export interface Meta {
    createdAt: string; // ISO date
    updatedAt: string; // ISO date
}

export enum Status {
    ACTIVE = "ACTIVE",
    ARCHIVED = "ARCHIVED",
}

export enum ErrorType {
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    FORBIDDEN = "FORBIDDEN",
    NONE = "NONE",
    VALIDATION_ERROR = "VALIDATION_ERROR",
    EMAIL_NOT_FOUND = "EMAIL_NOT_FOUND",
    EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
}

export const ErrorCode: { [T in ErrorType]: number } = {
    [ErrorType.UNKNOWN_ERROR]: 500,
    [ErrorType.FORBIDDEN]: 403,
    [ErrorType.NONE]: 200,
    [ErrorType.VALIDATION_ERROR]: 400,
    [ErrorType.EMAIL_NOT_FOUND]: 404,
    [ErrorType.EMAIL_ALREADY_EXISTS]: 400,
};
